export const APP_NAME = 'kindbody';

export const logDeploymentInfo = (): void => {
  const commitNameAndHash: string = import.meta.env.VITE_APP_DEPLOYED_COMMIT;
  if (import.meta.env.VITE_APP_ENV == 'production' || !commitNameAndHash) return;

  const [name, hash] = commitNameAndHash.split(/-(?=[^-]*$)/);

  console.log('DEPLOYED COMMIT: ', { name, hash });
};
